// Sort function - value = property name from api; type = type of value
export const sortFunc = ({ data = [], value, type, ascending = true }) => {
  const sortedData = [...data];

  if (ascending) {
    switch (type) {
      case "string":
        sortedData.sort((a, b) => ("" + a[value]).localeCompare(b[value]));

        break;

      case "date":
        sortedData.sort(
          (a, b) => new Date(b[value]).getTime() - new Date(a[value]).getTime()
        );

        break;
      case "boolean":
        sortedData.sort((a, b) => b[value] - a[value]);

        break;
      case "number":
        sortedData.sort((a, b) => a[value] - b[value]);

        break;

      default:
        break;
    }
  } else {
    switch (type) {
      case "string":
        sortedData.sort((a, b) => ("" + b[value]).localeCompare(a[value]));

        break;

      case "date":
        sortedData.sort(
          (a, b) => new Date(a[value]).getTime() - new Date(b[value]).getTime()
        );

        break;
      case "boolean":
        sortedData.sort((a, b) => a[value] - b[value]);

        break;
      case "number":
        sortedData.sort((a, b) => b[value] - a[value]);

        break;

      default:
        break;
    }
  }
  return sortedData;
};
